import create from "zustand";

const pauseAnimationStore = create((set) => ({
  pauseAnimation: true,
  setPauseAnimation: (pauseAnimation) => set({ pauseAnimation }),
}));

export default pauseAnimationStore;